import { categoryOptions } from '@/features/lobby/constants/filter-options';
import CategoryButton from '../components/CategoryButton';
import PopoverMenu from '../components/PopoverMenu';
import useContextSafe from '../../../hooks/useContextSafe';
import LobbyFiltersContext from '../components/LobbyFiltersContext';
import LobbyTableDesktop from '../components/LobbyTableDesktop';
import InputSearch from '@/components/InputSearch/InputSearch';

const LobbyDesktopDisplay = () => {
  const {
    filters,
    handleCategory,
    handleNameSearch,
    handleRangeChange,
    handleTableSize,
    handleStakes,
    handleResetFilters,
    handleGames,
    handleGameType,
    handleSaveFilters,
    handleCloseWithoutSaving,
    handleEmptyTables,
    handleFullTables,
  } = useContextSafe(LobbyFiltersContext);

  return (
    <div className="flex flex-1 flex-col">
      <div className="scrollbar-phenom flex flex-row items-center gap-4 overflow-x-auto">
        {categoryOptions.map(({ category, image, title, activeImage, margin, comingSoon }) => (
          <CategoryButton
            key={category}
            Image={image}
            ActiveImage={activeImage}
            title={title}
            isActive={filters.category === category || false}
            onClick={() => handleCategory(category)}
            margin={margin}
            comingSoon={comingSoon}
          />
        ))}
      </div>

      <div className="flex items-center justify-between gap-4 py-5 align-middle">
        <InputSearch placeholder={'Search for a table...'} value={filters?.name} handleNameSearch={handleNameSearch} />

        <div className="peer flex items-center gap-5">
          <PopoverMenu
            filters={filters}
            isMobileView={false}
            onRangeChange={handleRangeChange}
            onTableSizeChange={handleTableSize}
            onStakes={handleStakes}
            onResetFilters={handleResetFilters}
            onGames={handleGames}
            onGameType={handleGameType}
            onSaveFilters={handleSaveFilters}
            onCloseWithoutSaving={handleCloseWithoutSaving}
            onFullTables={handleFullTables}
            onEmptyTables={handleEmptyTables}
            onFavoritesOnly={() => null} // TODO: Implement this function
          />
        </div>
      </div>

      <LobbyTableDesktop />
    </div>
  );
};

export default LobbyDesktopDisplay;
